module.exports = require("lodash.maxby");